(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["si-chapters-purchase"] && !Shopify.designMode) return;
  try {
    (() => {
  const busyText = 'Adding…';
  const init = field => {
    if (field.dataset.initialized) return;
    const root = field.closest('.si-chapter');
    const form = field.closest('form');
    if (!root || !form) return;
    const quantity = form.querySelector('[name="quantity"]');
    field.dataset.initialized = 'true';
    form.setAttribute('data-si-chapters-purchase', '');
    const d = field.dataset;
    const fmt = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency: root.dataset.currency || 'USD'});
    const money = cents => fmt.format(Number(cents) / 100);
    const errorEl = field.querySelector('[data-purchase-error]');
    const price = root.querySelector('.si-price');
    const perTattoo = root.querySelector('.si-per-tattoo');
    const onceSticky = root.querySelector('.si-sticky span:not([data-total])');
    const oncePriceText = price ? price.textContent : '';
    const oncePerText = perTattoo ? perTattoo.textContent : '';
    const onceStickyText = onceSticky ? onceSticky.textContent : '';
    // form.id would return the <input name="id">, so read the attribute.
    const formId = form.getAttribute('id') || '';
    const buttons = () => [...new Set([...form.querySelectorAll('button[type="submit"], button[data-si-cp-btn]'), ...(formId ? document.querySelectorAll('button[form="' + CSS.escape(formId) + '"]') : [])])];
    let busy = false;
    let savedQty = quantity ? quantity.value : '1';
    let mode = 'once';
    const state = () => {
      const radio = field.querySelector('input[type="radio"]:checked');
      if (radio && radio.value === 'club' && d.clubId) return 'club';
      return 'once';
    };
    const qty = () => Math.max(1, Math.min(99, parseInt(quantity && quantity.value, 10) || 1));
    const label = m => m === 'club' ? 'Join Chapters Club · ' + money(d.clubPrice) : 'Add to cart · ' + money(Number(d.oncePrice) * qty());
    const paint = () => {
      buttons().forEach(b => {
        b.setAttribute('data-si-cp-btn', '');
        // Every add goes through our handler, so HS Slide Cart's fast-cart hooks (which add without opening the drawer) never see a submit button.
        b.type = 'button';
        if (!busy) b.textContent = label(mode);
      });
    };
    const apply = () => {
      const next = state();
      if (next !== 'once' && mode === 'once' && quantity) savedQty = quantity.value;
      if (next === 'once' && mode !== 'once' && quantity) quantity.value = savedQty;
      mode = next;
      root.dataset.purchase = mode;
      const terms = field.querySelector('[data-club-terms]');
      if (terms) terms.hidden = mode !== 'club';
      root.dataset.clubSelected = String(mode === 'club');
      if (quantity) {
        quantity.readOnly = mode !== 'once';
        if (mode !== 'once') quantity.value = '1';
      }
      root.querySelectorAll('[data-quantity]').forEach(b => { b.disabled = mode !== 'once'; });
      if (price) price.textContent = mode === 'club' ? money(d.clubPrice) : oncePriceText;
      if (perTattoo) perTattoo.textContent = mode === 'club' ? money(Math.round(Number(d.clubPrice) / 24)) + ' per design' : oncePerText;
      if (onceSticky) onceSticky.textContent = mode === 'club' ? '3 Chapters every 60 days' : onceStickyText;
      if (errorEl) errorEl.hidden = true;
      paint();
    };
    const items = () => {
      if (mode === 'club') return [{id: Number(d.clubId), quantity: 1, selling_plan: Number(d.clubPlan), properties: {[d.firstLabel]: d.firstPack}}];
      return [{id: Number(d.onceId), quantity: qty()}];
    };
    // Same count the theme's HS drawer script uses (snippets/si-layout-pdp-drawer-script.liquid).
    const hsQty = () => [...document.querySelectorAll('.hs-site-cart-popup-layout .hs-item-cart-content')].reduce((t, el) => t + Number(el.getAttribute('data-item-qty') || 0), 0);
    const wait = (test, ms) => new Promise(resolve => { const start = Date.now(); const tick = () => { if (test() || Date.now() - start > ms) return resolve(); setTimeout(tick, 100); }; tick(); });
    const openDrawer = async before => {
      ['cart:refresh', 'cart:updated'].forEach(name => { try { document.dispatchEvent(new CustomEvent(name, {bubbles: true, detail: {}})); } catch (e) {} });
      const link = document.querySelector('a[aria-controls="cart-drawer"]');
      if (document.querySelector('.hs-site-cart-popup-layout, .hs-popup-cart-sp-load')) {
        await wait(() => hsQty() > before, 2500);
        await new Promise(r => setTimeout(r, 250));
      }
      if (document.body.classList.contains('hs-open-cart')) return;
      if (link) {
        link.click();
        await wait(() => document.body.classList.contains('hs-open-cart'), 1500);
        if (document.body.classList.contains('hs-open-cart')) return;
      }
      const drawer = document.getElementById('cart-drawer') || document.querySelector('cart-drawer');
      if (drawer && typeof drawer.show === 'function') { try { drawer.show(); return; } catch (e) {} }
      window.location.href = d.cartUrl || '/cart';
    };
    const setBusy = on => {
      busy = on;
      buttons().forEach(b => {
        if (on) { b.dataset.siWasDisabled = b.disabled ? '1' : ''; b.disabled = true; b.setAttribute('aria-busy', 'true'); b.textContent = busyText; }
        else { b.disabled = b.dataset.siWasDisabled === '1'; b.removeAttribute('aria-busy'); }
      });
      if (!on) paint();
    };
    const ours = el => {
      const b = el && el.closest && el.closest('button');
      return !!b && (b.form === form || form.contains(b)) && b.hasAttribute('data-si-cp-btn');
    };
    const block = event => { event.preventDefault(); event.stopPropagation(); event.stopImmediatePropagation(); };
    const add = async () => {
      if (busy) return;
      apply();
      const before = hsQty();
      setBusy(true);
      try {
        const root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const res = await fetch(root_url + 'cart/add.js', {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest'}, body: JSON.stringify({items: items()})});
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.description || data.message || d.error);
        await openDrawer(before);
      } catch (err) {
        if (errorEl) { errorEl.textContent = (err && err.message) || d.error; errorEl.hidden = false; }
      } finally {
        setBusy(false);
      }
    };
    // Window capture runs before any document or element listener (HS Slide Cart included).
    // One-time and Club both add here (one POST /cart/add.js), then open the drawer. add() ignores repeat clicks while busy.
    window.addEventListener('click', event => {
      if (!ours(event.target)) return;
      block(event);
      add();
    }, true);
    window.addEventListener('submit', event => {
      if (event.target !== form) return;
      block(event);
      add();
    }, true);
    field.querySelectorAll('input').forEach(input => input.addEventListener('change', apply));
    if (quantity) quantity.addEventListener('change', () => setTimeout(paint, 0));
    root.querySelectorAll('[data-quantity]').forEach(b => b.addEventListener('click', () => setTimeout(paint, 0)));
    const wanted = new URLSearchParams(window.location.search).get('purchase');
    if (wanted === 'club' && d.clubId) { const r = field.querySelector('input[value="club"]'); if (r) r.checked = true; }
    const discTpl = field.querySelector('template[data-si-extras-disclosure]');
    const loox = root.querySelector('#looxReviews');
    if (discTpl && loox && !root.querySelector('.si-review-disclosure')) loox.before(discTpl.content.cloneNode(true));
    field.hidden = false;
    apply();
    window.addEventListener('pageshow', () => { setBusy(false); apply(); });
  };
  const mount = scope => {
    const tpl = document.getElementById('si-chapters-purchase-tpl');
    if (tpl) document.querySelectorAll('.si-chapter form.si-product-form').forEach(form => {
      if (form.querySelector('[data-si-purchase]')) return;
      const id = form.querySelector('[name="id"]');
      if (id) id.after(tpl.content.cloneNode(true));
    });
    scope.querySelectorAll('[data-si-purchase]').forEach(init);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document)); else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["spectrum-product-rating"] && !Shopify.designMode) return;
  try {
    // Clicking a Loox badge on its own product page scrolls to its review widget.
// Lives with the badge (not a section) so it works on every template the badge is on.
(function () {
  if (window.__siLooxRatingScroll) return;
  window.__siLooxRatingScroll = true;
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-loox-product-rating]') : null;
    if (!a || a.origin !== window.location.origin || a.pathname !== window.location.pathname) return;
    var t = document.getElementById(a.hash.slice(1));
    if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  }, false);
})();
  } catch(e) { console.error(e); }
})();

})();
